import { Typography } from '@material-ui/core';
import styled from 'styled-components';

const StyledTraceBoardEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  margin: 56px 46px;
  align-self: center;
  background-color: white;
  align-content: center;
  justify-content: center;
  text-align: center;
  img {
    align-self: center;
    width: 240px;
    margin-top: 20px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    width: 65%;
  }
  ${props => props.theme.breakpoints.only('xs')} {
    padding: 50px 24px;
  }
`;

export function TraceBoardEmptyState() {
  return (
    <StyledTraceBoardEmptyState>
      <img alt='Empty Trace Board' src='/assets/empty-state-references.png' />
      <Typography variant='h6' style={{ marginTop: 50 }}>
        Looking a little empty?
      </Typography>
      <Typography variant='subtitle1'>
        Be the first to add content for traceability. Click the + icon in the
        column
      </Typography>
      <Typography variant='subtitle1'>above to get started</Typography>
    </StyledTraceBoardEmptyState>
  );
}
